export default "__VITE_ASSET__9029ce37__"